/**
 * Toggle net highlight on or off
 * @param {SVGSVGElement} svg the svg for which to apply the color profile
 * @param {object} profile the color profile to apply
 */
function applyColorProfile(svg: SVGSVGElement, profile: {data?: {opacity?: string, layers?: Record<string, string>}}): void {
  if (profile.data && profile.data.layers) {
    const opacity = profile.data.opacity;
    for (const layer of svg.querySelectorAll(`g[data-group="foreground"] [data-layer-id]`)) {
      const layerId = layer.getAttribute('data-layer-id');
      const color = layerId ? profile.data.layers[layerId] : undefined;
      if (color) {
        layer.setAttribute('color', color);
        layer.setAttribute('fill', color);
        if (opacity) layer.setAttribute('opacity', opacity);
      }
    }
  }
}

export {applyColorProfile};
